import { NavigationsClient, SsoClient } from '@treasury/api/channel';
import { getChannelAPIPath } from '@treasury/core/http';
import { Feature, FeatureFlagService } from '@treasury/domain/services/feature-flags';

NavigationService.$inject = ['$resource', 'TmDi'];

/**
 * @param { ng.resource.IResourceService} $resource
 * @param { import('@jack-henry/frontend-utils/di').DiContainer} TmDi
 */
export function NavigationService($resource, TmDi) {
    const resourceUrl = `${getChannelAPIPath()}navigations/`;

    return {
        getNavigation,
        startSso,
        userActivityAudit,
    };

    async function getNavigation() {
        const ffService = await TmDi.getAsync(FeatureFlagService);
        const navClient = await TmDi.getAsync(NavigationsClient);
        const ssoNavigationsEnabled = await ffService.isEnabled(Feature.SsoNavigations);

        if (ssoNavigationsEnabled) {
            return (await navClient.navigationsGetNavigationsWithSso()).data;
        } else {
            return (await navClient.navigationsGet()).data;
        }
    }

    /**
     * Begin the SSO process given a navigation item.
     * Upon completing the request, a redirect URI will be returned
     * which will complete the SSO process upon navigation to it.
     *
     * @param { import ('@treasury/api/channel').NavigationModelDto } navItem
     * @return The redirect URI.
     */
    async function startSso(navItem) {
        const { name, ssoUniqueId } = navItem;
        if (!ssoUniqueId) {
            throw new Error(`Cannot begin SSO for ${name}. It does not have a unique ID.`);
        }
        const ssoClient = await TmDi.getAsync(SsoClient);

        const { redirectTo } = (
            await ssoClient.initiateSsoPost({
                ssoUniqueId,
            })
        ).data;

        if (!redirectTo) {
            throw new Error(`Could not complete SSO for ${name}. No redirect was provided.`);
        }

        return redirectTo;
    }

    function userActivityAudit(navigation) {
        const request = $resource(`${resourceUrl}auditUserActivity/${navigation}`);
        return request.save().$promise;
    }
}
